var _rect, _polygon, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVisa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.45,
    width: 46,
    height: 30.1,
    rx: 3,
    fill: "#2852a4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "20.89 20.48 18.3 20.48 19.92 10.53 22.51 10.53 20.89 20.48",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.11,10.53l-2.47,6.84-.29-1.47h0l-.87-4.48a1.11,1.11,0,0,0-1.23-.89H7.16l0,.16a9.65,9.65,0,0,1,2.71,1.14l2.25,8.65h2.7l4.12-10Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5,20.48h2.38l-2.07-10H34.72a1.18,1.18,0,0,0-1.19.74l-3.87,9.21h2.7L32.9,19h3.3ZM33.65,17,35,13.23,35.78,17Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.86,12.92l.37-2.14a7.53,7.53,0,0,0-2.33-.43c-1.28,0-4.34.56-4.34,3.29,0,2.58,3.59,2.61,3.59,4s-3.22,1.11-4.28.26l-.39,2.23a7.31,7.31,0,0,0,2.93.56c1.77,0,4.44-.91,4.44-3.41s-3.62-2.83-3.62-3.95S28.76,12.31,29.86,12.92Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.35,15.9l-.87-4.48a1.11,1.11,0,0,0-1.23-.89H7.16l0,.16A10,10,0,0,1,11,12.63,7.74,7.74,0,0,1,13.35,15.9Z",
    fill: "#f8a533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisa);
export default __webpack_public_path__ + "static/media/ic_visa.1bf0ee28cf230e8fc870099f00317994.svg";
export { ForwardRef as ReactComponent };